import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../header/header";
import Footer from "../footer/footer";
import Footer1 from "../footer/footer1";
import './inform.css'
function Informations() {
  const [informations, setInformations] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Tous");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [infoResponse, categoriesResponse] = await Promise.all([
          axios.get("http://localhost:8081/api/plateforme/information/approuvees"),
          axios.get("http://localhost:8081/api/plateforme/categorie/liste"),
        ]);
        setInformations(infoResponse.data);
        setCategories([{ id: "Tous", nom: "Tous" }, ...categoriesResponse.data]);
      } catch (err) {
        console.error("Erreur lors de la récupération des données :", err);
        setError("Impossible de récupérer les données.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Chargement des informations...</div>;
  if (error) return <div>{error}</div>;

  const filteredInformations =
    selectedCategory === "Tous"
      ? informations
      : informations.filter((info) => info.categorieId === selectedCategory);

  return (
    <div>
      <Header />
      <div
        className="inner-hero bg-cover"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-heading">
                <h1>Informations</h1>
                <h3 style={{ fontSize: "18px", color: "white" }}>L'actualité représente un ensemble de données ou de connaissances partagées afin d'éclairer, de sensibiliser ou d'éduquer un public sur un sujet spécifique.</h3>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="blog1 sp bg1 _relative">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 m-auto text-center">
              <div className="categories-buttons">
                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                  {categories.map((category) => (
                    <li className="nav-item" key={`category-${category.id}`} role="presentation">
                      <button
                        className={`nav-link ${
                          selectedCategory === category.id ? "active" : ""
                        }`}
                        onClick={() => setSelectedCategory(category.id)}
                      >
                        {category.nom}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            {Array.isArray(filteredInformations) && filteredInformations.length > 0 ? (
              filteredInformations.map((info) => (
                <div
                  className="col-md-6 col-lg-4"
                  key={info.id}
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="400"
                  data-aos-delay="300"
                >
                  <div className="blog1-single-box sm:mt-30">
                    <div className="heading1">
                      <h4 style={{ color: "#F29F3D", fontWeight: "bold" }}>{info.titre}</h4>
                      <p className="mt-16">{info.contenu}</p>
                      <div className="date-area d-flex justify-content-between align-items-center">
                        <div className="date">
                          <span className="icon-red">
                            <img
                              src="assets/img/icons/date1.svg"
                              alt="start-date"

                            />{" "}
                            {info.dateDebut || "Date de début inconnue"}
                          </span>
                        </div>
                        <div className="date">
                          <span className="icon-red">
                            <img
                              src="assets/img/icons/date1.svg"
                              alt="end-date"
                            />{" "}
                            {info.dateFin || "Date de fin inconnue"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div>Aucune information disponible.</div>
            )}
          </div>
        </div>
      </div>

      <Footer1 />
      <Footer />
    </div>
  );
}

export default Informations;
